export async function copyToClipboard(text: string): Promise<void> {
  const value = String(text);

  // 95% of user should have a support of the asynchronous Clipboard API - https://caniuse.com/mdn-api_clipboard_writetext
  if (typeof navigator !== "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch (error) {
      // ignore and fallback to execCommand
    }
  }

  if (typeof document === "undefined" || !document.body) {
    throw new Error("Clipboard API is not available in this environment.");
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "-9999px";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";

  document.body.appendChild(textarea);

  const selection = document.getSelection();
  const originalRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

  textarea.select();
  textarea.setSelectionRange(0, value.length);

  let succeeded = false;

  try {
    succeeded = document.execCommand("copy");
  } catch (error) {
    succeeded = false;
  } finally {
    document.body.removeChild(textarea);
    if (originalRange && selection) {
      selection.removeAllRanges();
      selection.addRange(originalRange);
    }
  }

  if (!succeeded) {
    throw new Error("Unable to copy text to clipboard.");
  }
}
